import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { ShipmentDetailPage } from '@ontruck/fe-ontime';

export function LastMileShipmentDetailModule() {
  const { id } = useParams();
  const history = useHistory();

  const handleGoToShipmentsList = () => {
    history.push('/last-mile/shipments');
  };

  return <ShipmentDetailPage shipmentId={id} onCloseDetail={handleGoToShipmentsList} />;
}
